const UNWANTED_ENCLOSURES_REGEX = /[([{][^)\]}]*[)\]}]/g;
// oxlint-disable-next-line no-control-regex -- strips control characters so they never become avatar initials
const UNWANTED_CHARS_REGEX = /[\0-\u001F!-/:-@[-`{-\u00BF\u0250-\u036F\uD800-\uFFFF]/g;
const MULTIPLE_WHITESPACES_REGEX = /\s+/g;

export function cleanupDisplayName(displayName: string) {
    return displayName
        .replace(UNWANTED_ENCLOSURES_REGEX, "")
        .replace(UNWANTED_CHARS_REGEX, "")
        .replace(MULTIPLE_WHITESPACES_REGEX, " ")
        .trim();
}
